<template>

    <div class="behavior-report-step-1">

        <b-form validated horizontal>

            <b-form-group label="Report Card Title">
                <b-form-input required
                              v-model="docData.cardTitle">
                </b-form-input>
            </b-form-group>

            <b-form-group label="Student Name">
                <b-form-input required
                              v-model="docData.studentName">
                </b-form-input>
            </b-form-group>

            <b-form-group label="Student Pronouns">
                <b-form-select required
                               v-model="docData.studentPronouns"
                               :options="pronounOptions">
                </b-form-select>
            </b-form-group>

            <b-form-group label="Rater Name">
                <b-form-input required
                              v-model="docData.raterName">
                </b-form-input>
            </b-form-group>

        </b-form>

    </div>

</template>

<script>

    import Vue from 'vue'
    import ToolMixin from '@/providers/ToolMixin'

    export default Vue.extend({
        name: "BehaviorReportStep1",
        mixins: [ToolMixin],
        data() {
            return {
                pronounOptions: [
                    {value: 'he', text: 'He / His'},
                    {value: 'she', text: 'She / Her'},
                    {value: 'they', text: 'They / Their'},
                ]
            }
        },
        computed: {
            thisStepIsValid() {
                return this.docData.cardTitle
                    && this.docData.studentName
                    && this.docData.studentPronouns
                    && this.docData.raterName
            }
        },
    })

</script>
